export default __webpack_public_path__ + "media/images/react_icons/applemaps-b50441167a352081889f5fc6532feb87.svg";